import { render } from "./TermsOfUse.vue?vue&type=template&id=4ff27fc9&scoped=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"

import "./TermsOfUse.vue?vue&type=style&index=0&id=4ff27fc9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ff27fc9"

export default script